// ABOUTME: Reusable contact action button with custom icon and Lucide fallback
// ABOUTME: Used in TradePersonCard for phone, SMS, WhatsApp, and email actions

import React from 'react';
import { Button } from '@/components/ui/button';
import { getCustomActionIconSrc } from '@/lib/tradeUtils';
import { LucideIcon } from 'lucide-react';

interface ContactActionButtonProps {
  /** Action type key for looking up custom icon (e.g., 'phone', 'sms', 'whatsapp', 'email') */
  actionType: string;
  /** Display label for alt text and aria-label */
  label: string;
  /** Lucide icon component used as fallback if no custom icon exists */
  FallbackIcon: LucideIcon;
  /** Click handler — receives the original event */
  onClick: (e: React.MouseEvent) => void;
}

export function ContactActionButton({ actionType, label, FallbackIcon, onClick }: ContactActionButtonProps) {
  const customIconSrc = getCustomActionIconSrc(actionType);

  return (
    <Button
      size="sm"
      variant="ghost"
      className="p-3 hover:bg-purple-50 text-purple-700 transition-all active:scale-95 rounded-lg"
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
      aria-label={label}
    >
      {customIconSrc ? (
        <div className="relative h-10 w-10">
          <img
            src={customIconSrc}
            alt={label}
            className="h-10 w-10"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
              const fallback = e.currentTarget.nextElementSibling as HTMLElement;
              if (fallback) {
                fallback.classList.remove('hidden');
              }
            }}
          />
          <FallbackIcon className="h-10 w-10 hidden" />
        </div>
      ) : (
        <FallbackIcon className="h-10 w-10" />
      )}
    </Button>
  );
}
